export default "__VITE_ASSET__DUgtkv0H__"